export const chartColours = {
  ldnDkPink: "#9e0059",
  yellow: "#dee000",
  red: "#d82222",
  green: "#5ea15d",
  purple: "#943fa6",
  turquoise: "#63c5b5",
  pink: "#ff38ba",
  orange: "#eb861e",
  ldnPink: "#ee266d",
  darkBlue: "#2e6593",
};

export const chartColoursList = [
  "#000000", // black
  "#2e6593", // dark blue
  "#467978", // turquoise
  "#5D8D5D", // green
  "#d3de57", // yellow
  "#a68e50", // mud
  "#9e5351", // brick
  "#de8883", // light pink
  "#5e236d", // purple
  "#9E0059", // ldnDkPink
];
